import { gql } from '@apollo/client';

export const GET_ACCOUNT_LIST = gql`
  query GetAccountList {
    accounts {
      id
      name
      email
      suspended
      showNewFeatures
      achOnly
      contactName
      phoneNumber
      subdomain
      subdomainTitle
      isSystemAdmin
      currentSeason {
        vendorCount
        marketCount
      }
      createdAt
    }
  }
`;

export const DELETE_ACCOUNTS = gql`
  mutation DeleteAccounts($ids: [String!]!) {
    deleteAccounts(ids: $ids) {
      result
    }
  }
`;

export const GET_ACCOUNT = gql`
  query GetAccount($accountId: String!) {
    account(id: $accountId) {
      id
      name
      email
      suspended
      showNewFeatures
      achOnly
      contactName
      phoneNumber
      subdomain
      subdomainTitle
      users {
        id
      }
      isSystemAdmin
      createdAt
    }
  }
`;

export const GET_ACCOUNT_USERS = gql`
  query GetAccountUsers($accountId: String!) {
    account(id: $accountId) {
      id
      users {
        id
        name
        username
        email
        suspended
        permissions {
          users
          vendors
          billing
          metrics
          attendance
          formBuilder
          marketsAndPricing
          marketSales
          marketPages
          vendorPlacement
          settings
        }
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($accountId: String!, $user: CreateUserInput!) {
    createUser(accountId: $accountId, data: $user) {
      id
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($id: String!, $updates: UpdateUserInput!) {
    updateUser(id: $id, updates: $updates) {
      id
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: String!) {
    deleteUser(id: $id) {
      result
    }
  }
`;
